import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';

import Intervention from "../../../services/Intervention";
import TiresAndWheelsServices from "./TiresAndWheelsServices";
import AppointmentServicesCard from "./AppointmentServicesCard";

class ServicesCardWrapper extends Component {

  render() {
    const {intervention, canWrite} = this.props;
    return (
      <div>
        {Intervention.isTypeAppointmentOrBodywork(intervention) &&
          <AppointmentServicesCard canWrite={canWrite}/>
        }
        {Intervention.isTypeTire(intervention) &&
          <TiresAndWheelsServices canWrite={canWrite} intervention={intervention}/>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention,
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ServicesCardWrapper))
